import { observe } from './observe';
export function createState(
// Doesn't accept a setter function, as it's not a hook that stores state
// between renders and thus it wouldn't make sense to do so.
initialState) {
    var hasState = arguments.length !== 0;
    var state = initialState;
    var next = null;
    var setState = function (stateOrUpdater) {
        hasState = true;
        state =
            typeof stateOrUpdater === 'function'
                ? stateOrUpdater(state)
                : stateOrUpdater;
        if (next) {
            next(state);
        }
    };
    var source = observe(function (onNext) {
        next = onNext;
        if (hasState) {
            onNext(state);
        }
        return function () {
            next = null;
        };
    });
    return [source, setState];
}
